export const SET_VELOCITY_CHECK_PROCESSING = 'SET_VELOCITY_CHECK_PROCESSING'
export const SET_VELOCITY_CHECK_DATA = 'SET_VELOCITY_CHECK_DATA'
export const SET_VELOCITY_AUTHORIZATION = 'SET_VELOCITY_AUTHORIZATION'

export function setVelocityCheckProcessing (value) {
  return {
    type: SET_VELOCITY_CHECK_PROCESSING,
    payload: value,
  }
}

export function setVelocityCheckData (data, processing = false) {
  return {
    type: SET_VELOCITY_CHECK_DATA,
    payload: { data, processing },
  }
}

export function setVelocityAuthorization (success, reason) {
  return {
    type: SET_VELOCITY_AUTHORIZATION,
    payload: { success, reason },
  }
}
